import { Role } from '../enums/role';

export const TUTOR_ROLES = [Role.Tutor_Internal, Role.Tutor_External] as const;

export function isTutorRole(role: Role): boolean {
    return TUTOR_ROLES.some((tutorRole) => tutorRole === role);
}
